import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAward } from '@fortawesome/free-solid-svg-icons';
import { BADGE_ICON } from '../Competitions/BadgeShelf';
import './WallOfFame.css';

const API = process.env.REACT_APP_API_BASE_URL;
const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem('userData')}` } });

const ago = (v) => {
  const d = new Date(v);
  const days = Math.floor((Date.now() - d.getTime()) / 86400000);
  if (Number.isNaN(days)) return '';
  if (days <= 0) return 'Today';
  if (days === 1) return 'Yesterday';
  if (days < 7) return `${days} days ago`;
  return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
};

const Face = ({ x }) => {
  const [broken, setBroken] = useState(false);
  return (
    <span className="rmwf-face">
      {x.photo && !broken ? <img src={x.photo} alt="" loading="lazy" onError={() => setBroken(true)} /> : <span>{String(x.name || '?').replace('Teacher ', '').charAt(0)}</span>}
      <i className={`rmwf-badge is-${x.badge}`} aria-hidden="true">
        <FontAwesomeIcon icon={BADGE_ICON[x.icon] || faAward} />
      </i>
    </span>
  );
};

/* "Wall of fame": who earned a badge or a medal lately (students and teachers).
   path: '/api/student/awards/feed' or '/api/teacher/awards/feed'. Shows a short message when nobody has one yet. */
const WallOfFame = ({ path, max = 6, className = '', empty }) => {
  const [feed, setFeed] = useState(null);
  const [all, setAll] = useState(false);

  useEffect(() => {
    let cancelled = false;
    axios
      .get(`${API}${path}`, auth())
      .then((res) => !cancelled && setFeed(res.data?.feed || []))
      .catch(() => !cancelled && setFeed([]));
    return () => {
      cancelled = true;
    };
  }, [path]);

  if (!feed) return null;
  const shown = all ? feed : feed.slice(0, max);

  return (
    <section className={`rmwf ${className}`} aria-labelledby="rmwf-title">
      <h2 id="rmwf-title" className="rmwf-title">
        <span aria-hidden="true">🎉</span> Wall of fame
      </h2>
      {feed.length === 0 && (
        <p className="rmwf-empty">
          {empty || 'No badges yet this month. Join the class on time, work hard and send a project to a challenge: your name could be here first! 🌟'}
        </p>
      )}
      <ul className="rmwf-list">
        {shown.map((x) => (
          <li key={x.id} className={x.mine ? 'is-mine' : ''}>
            <Face x={x} />
            <div className="rmwf-text">
              <p>
                <b>{x.mine ? 'You' : x.name}</b> earned <strong>{x.title}</strong>
                {x.period ? <span className="rmwf-dim"> · {x.period}</span> : null}
              </p>
              {x.note && <p className="rmwf-note">“{x.note}”</p>}
              <small>{x.mine ? 'Well done! 🌟 · ' : ''}{ago(x.at)}</small>
            </div>
          </li>
        ))}
      </ul>
      {feed.length > max && (
        <button type="button" className="rmwf-more" onClick={() => setAll((v) => !v)}>
          {all ? 'Show less' : `See all ${feed.length}`}
        </button>
      )}
    </section>
  );
};

export default WallOfFame;
